import React, { useEffect, useRef, useState } from 'react';
import QRCode from 'qrcode.react';
import { useStore } from '../../../stores/store';

import { Button, Grid } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import ReactToPrint from 'react-to-print';
import { userLanguage } from '../../userLanguageSchema/userLanguage';

interface Props {
  id: string;
  isScan?:boolean
}
function QrCodeGenerator({ id,isScan = true }: Props) {
  const { dashboardStore, commonStore } = useStore();
  const componentRef = useRef<HTMLDivElement>(null);
  const [itemId, setItemId] = useState('');
  // updating
  useEffect(() => {
    setItemId(id);
  }, [id]);

  useEffect(() => {
    setItemId(dashboardStore.dashboard.getQrCodeValue);
  }, [dashboardStore.dashboard.getQrCodeValue]);

  return (
    <>
      <div ref={componentRef} style={{ marginTop: '20px' }}>
        <Grid>
          <QRCode
            value={itemId}
            id="canvas"
            style={{
              width: '140px',
              height: '110px',
              marginLeft: 'auto',
              marginRight: 'auto',
              marginBottom: '10px',
            }}
          />
        </Grid>
        {!isScan && <span style={{fontSize:'11px',marginTop:'6px',display:'flex',justifyContent:'center'}}>{id}</span>}
      </div>
      {isScan && <Grid>
        <Grid.Row columns={2}>
          <Grid.Column>
            <Button.Group floated="right">
              <Button
                color="teal"
                onClick={() => dashboardStore.setOpenQrCodeScanner(true)}
                //Scan
              >
                {
                  (
                    userLanguage[0].Level3InventoryRecievingTag?.IRTB01 as any
                  )?.[`${commonStore.language.key}`]
                }
              </Button>
            </Button.Group>
          </Grid.Column>
          <Grid.Column>
            <ReactToPrint
              trigger={() => (
                <Button
                  variant="contained"
                  color="teal"
                  //Print
                >
                  {
                    (
                      userLanguage[0].Level3InventoryRecievingTag?.IRTB02 as any
                    )?.[`${commonStore.language.key}`]
                  }
                </Button>
              )}
              content={() => componentRef.current}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>}
    </>
  );
}

export default observer(QrCodeGenerator);
